import { SvgProps } from "../../types";

const Manu = (props: SvgProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={4}
    height={16}
    fill="none"
    {...props}>
    <path
      fill="#B0B2B7"
      d="M2.076 16c-.55 0-1.02-.196-1.413-.588A1.926 1.926 0 0 1 .076 14c0-.55.196-1.02.587-1.412A1.926 1.926 0 0 1 2.076 12c.55 0 1.02.196 1.412.588.392.391.588.862.588 1.412 0 .55-.196 1.02-.588 1.412A1.926 1.926 0 0 1 2.076 16Zm0-6c-.55 0-1.02-.196-1.413-.588A1.926 1.926 0 0 1 .076 8c0-.55.196-1.02.587-1.412A1.926 1.926 0 0 1 2.076 6c.55 0 1.02.196 1.412.588.392.391.588.862.588 1.412 0 .55-.196 1.02-.588 1.412A1.926 1.926 0 0 1 2.076 10Zm0-6c-.55 0-1.02-.196-1.413-.587A1.926 1.926 0 0 1 .076 2c0-.55.196-1.02.587-1.413A1.926 1.926 0 0 1 2.076 0c.55 0 1.02.196 1.412.588.392.391.588.862.588 1.412 0 .55-.196 1.02-.588 1.413A1.926 1.926 0 0 1 2.076 4Z"
    />
  </svg>
);
export default Manu;
